import SEOHead from '@/components/feature/SEOHead';
import Layout from '@/components/feature/Layout';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '日韩在线首页 - 日韩国产在线与日韩激情在线高清视频平台',
    description: '日韩在线品牌专区汇聚日韩国产在线、日韩激情在线、日韩精品在线及日韩久久在线等全部分区，提供日韩剧、综艺、动漫等最新高清视频免费在线观看。',
    url: 'https://rihanzaixian.com/',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '日韩在线提供哪些类型的内容？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '日韩在线平台汇聚了日本和韩国地区最全面的影视内容，涵盖日剧、韩剧、日本动漫、韩国综艺、日本综艺、日韩电影等多个分类。',
        },
      },
      {
        '@type': 'Question',
        name: '日韩在线如何保证视频的高清画质？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '日韩在线采用先进的视频编码技术和全球CDN加速网络，确保所有视频内容均支持1080P至4K超高清画质。',
        },
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://rihanzaixian.com/',
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <SEOHead
        title="日韩在线 | 日韩国产在线与日韩激情在线高清一区二区 | 日韩精品在线久久免费观看全集"
        description="日韩在线品牌专区汇聚日韩国产在线、日韩激情在线、日韩精品在线及日韩久久在线等全部分区，提供日韩剧、综艺、动漫等最新高清视频免费在线观看，不缓冲全集体验。"
        keywords="日韩在线,日韩国产在线,日韩激情在线,日韩精品在线,日韩久久在线,日韩高清在线一区,日韩高清在线一区二区,日本最新在线视频,韩国最新在线视频,日韩剧在线观看,日韩综艺在线,日韩动漫在线"
        canonicalUrl="https://rihanzaixian.com/"
        schemaData={homeSchema}
      />

      <Layout>
        <article>
          <Hero />
          <CategoryNav />
          <FeaturedSection />
          <ArticleSection />
          <FAQSection />
          <NewsletterSection />
        </article>
      </Layout>
    </>
  );
}